import { Button, ConfigProvider } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const Confirm = ({
  loading = false,
  type = "primary",
  icon = <PlusOutlined />,
  title = "button.add",
  onClick = () => {},
  id = "btn-ghost",
  ...props
}) => {
  const { t } = useTranslation();

  const translatedTitle = title === "button.add" ? t(title) : title;

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#7bf1a8",
        },
      }}
    >
      <Button
        // disabled={loading}
        type={type}
        icon={icon}
        onClick={onClick}
        id={id}
        title={translatedTitle}
        style={{ color: "#000000" }}
        loading={loading}
        {...props}
      >
        {translatedTitle}
      </Button>
    </ConfigProvider>
  );
};

export default Confirm;
